import { useQuery } from '@tanstack/react-query'
import { getMeSession } from '@/features/auth/api'
import { authSessionQueryKey } from '@/features/auth/hooks/auth-query-keys'
import { partialSessionFromPersistedAuth } from '@/features/auth/lib/session-display'
import { isAuthenticated } from '@/features/auth/session/workspace-session'
import { useHttpClient } from '@/shared/api/http-client-context'

export function useMeSessionQuery(enabled = true) {
  const client = useHttpClient()
  return useQuery({
    queryKey: authSessionQueryKey,
    queryFn: () => getMeSession(client),
    enabled: enabled && isAuthenticated(),
    placeholderData: () => partialSessionFromPersistedAuth(),
    staleTime: 60_000,
    retry: 1,
  })
}
